import { ResponsiveValue, Text, TextProps } from "@chakra-ui/react"
import * as CSS from "csstype"

const FormText = ({
  children,
  ...rest
}: {
  children: React.ReactNode
} & TextProps) => {
  const color = rest.color ?? "white"
  const fontSize = rest.fontSize ?? "14px"
  const textAlign = rest.textAlign ?? "left"
  const fontWeight = rest.fontWeight ?? "normal"
  return (
    <Text
      fontFamily="-apple-system, 'system-ui', 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"
      color={color}
      textAlign={textAlign}
      fontSize={fontSize}
      lineHeight="1.1rem"
      mt=".2rem"
      {...rest}
    >
      {children}
    </Text>
  )
}

export default FormText
